<template>
  <div v-loading.body="loading">
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="次品组：">
                  <el-input
                    v-model="form.group_name"
                    placeholder="次品组"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="城市：">
                  <el-select
                    v-model="form.city"
                    placeholder="城市"
                    @change="() => onCityChange(FORM_TYPE.QUERY)"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in citys"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="市场：">
                  <el-select
                    v-model="form.market_id"
                    filterable
                    clearable
                    placeholder="市场"
                    @change="() => onMainMarketChange(FORM_TYPE.QUERY)"
                  >
                    <el-option
                      v-for="item in marketList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="子市场：">
                  <el-select
                    v-model="form.market_sub_id"
                    filterable
                    clearable
                    placeholder="子市场"
                  >
                    <el-option
                      v-for="item in subMarketList"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-select v-model="form.status" placeholder="状态">
                  <el-option key="" value="" label="全部"></el-option>
                  <el-option
                    v-for="item in isUse"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <el-form-item label="创建时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col v-if="resData" :span="24" class="data-statics">
        数据汇总:&nbsp;&nbsp;&nbsp;&nbsp;次品组{{ resData.total }}组
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <el-button
            style="margin-left: auto"
            type="primary"
            size="mini"
            @click="addPg"
            >+创建次品组
          </el-button>
          <el-button type="success" size="mini" @click="output">导出</el-button>
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column
              align="center"
              prop="dgid"
              label="次品组id"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="group_name"
              label="次品组"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="defective_group_city"
              label="城市"
            ></el-table-column>
            <el-table-column align="center" prop="market_name" label="市场">
              <template #default="{ row }">
                <div class="market-name-wrap">
                  <div style="max-height: 200px; overflow-y: auto">
                    <div
                      v-for="item in row.isMarketShowAll
                        ? row.market_names.split('、')
                        : row.market_names.split('、').slice(0, 5)"
                      :key="item"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <el-button
                    v-if="row.market_names.split('、').length > 5"
                    type="text"
                    size="small"
                    ghost
                    @click="handleShowModalMore(row, 'Market')"
                  >
                    {{ row.isMarketShowAll ? "收起" : "查看全部" }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="market_sub_names"
              label="子市场"
            >
              <template #default="{ row }">
                <div class="market-name-wrap">
                  <div style="max-height: 200px; overflow-y: auto">
                    <div
                      v-for="item in row.isMarketSubShowAll
                        ? row.market_sub_names.split('、')
                        : row.market_sub_names.split('、').slice(0, 5)"
                      :key="item"
                    >
                      {{ item }}
                    </div>
                  </div>
                  <el-button
                    v-if="row.market_sub_names.split('、').length > 5"
                    type="text"
                    size="small"
                    ghost
                    @click="handleShowModalMore(row, 'MarketSub')"
                  >
                    {{ row.isMarketSubShowAll ? "收起" : "查看全部" }}
                  </el-button>
                </div>
              </template></el-table-column
            >
            <el-table-column
              align="center"
              prop="supply_num"
              label="绑定商家数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="member_num"
              label="次品员数量"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="defective_group_status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="创建时间"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="180">
              <template #default="scope">
                <el-button type="text" @click="editDg(scope.row)">
                  编辑
                </el-button>
                <el-button type="text" @click="PgLog(scope.row)">
                  查看日志
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-dialog title="操作日志" :visible.sync="logVisible">
            <el-table :data="logData">
              <el-table-column
                property="action_type"
                label="事件"
                align="center"
              ></el-table-column>
              <el-table-column label="内容" align="center">
                <template #default="scope">
                  <div v-html="scope.row.action_desc" />
                </template>
              </el-table-column>
              <el-table-column
                property="action_admin"
                label="操作人"
                align="center"
              ></el-table-column>
              <el-table-column
                property="create_time"
                label="操作时间"
                align="center"
              ></el-table-column>
            </el-table>
          </el-dialog>
          <el-dialog
            title="添加/编辑次品组"
            width="30%"
            :visible.sync="editVisible"
            :before-close="closeEditDefective"
          >
            <el-form
              :model="defective_form"
              label-width="100px"
              label-position="left"
            >
              <el-form-item
                label="次品组名称"
                required
                :hide-required-asterisk="true"
              >
                <el-input
                  v-model="defective_form.group_name"
                  style="width: 200px"
                ></el-input>
              </el-form-item>
              <el-form-item label="绑定城市" required>
                <el-select
                  v-model="defective_form.city"
                  placeholder="城市"
                  @change="() => onCityChange(FORM_TYPE.EDIT)"
                >
                  <div v-for="item in citys" :key="item.value">
                    <el-option
                      v-if="item.value > 0"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </div>
                </el-select>
              </el-form-item>
              <el-form-item
                v-if="Object.entries(defective_form.market_sub_id).length > 0"
                label="市场："
              >
                <el-card
                  class="box-card"
                  style="max-width: 1000px"
                  shadow="never"
                >
                  <el-tabs
                    v-model="activeTab"
                    type="card"
                    @tab-click="() => onMainMarketChange(FORM_TYPE.EDIT)"
                  >
                    <el-tab-pane
                      v-for="item in defectiveMarketList"
                      :key="item.key"
                      :label="item.label"
                      :name="item.key"
                    >
                      <span slot="label">
                        {{ item.label }}
                        <span
                          v-if="
                            defective_form.market_sub_id[`${item.key}`] &&
                            defective_form.market_sub_id[`${item.key}`].length >
                              0
                          "
                          style="color: #fc1"
                        >
                          （已选{{
                            defective_form.market_sub_id[`${item.key}`].length
                          }}个）
                        </span>
                      </span>
                    </el-tab-pane>
                  </el-tabs>
                  <el-checkbox-group
                    v-model="defective_form.market_sub_id[activeTab]"
                  >
                    <el-checkbox
                      v-for="v in defectiveSubMarketList"
                      :key="v.key"
                      :label="v.key"
                    >
                      {{ v.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-card>
              </el-form-item>

              <!-- <el-form-item label="市场：">
                <el-select
                  v-model="defective_form.market_id"
                  filterable
                  clearable
                  placeholder="市场"
                  @change="() => onMainMarketChange(FORM_TYPE.EDIT)"
                >
                  <el-option
                    v-for="item in defectiveMarketList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="子市场：">
                <el-select
                  v-model="defective_form.market_sub_id"
                  filterable
                  clearable
                  placeholder="子市场"
                >
                  <el-option
                    v-for="item in defectiveSubMarketList"
                    :key="item.key"
                    :label="item.label"
                    :value="item.key"
                  >
                  </el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item label="状态" required>
                <el-select v-model="defective_form.status" placeholder="状态">
                  <div v-for="item in isUse" :key="item.value">
                    <el-option
                      v-if="item.value > 0"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </div>
                </el-select>
              </el-form-item>
            </el-form>
            <template #footer class="dialog-footer">
              <el-button size="small" @click="editVisible = false">
                取 消
              </el-button>
              <el-button size="small" type="primary" @click="saveDefective">
                确 定
              </el-button>
            </template>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.page"
            background
            layout="total, prev, sizes, pager, next, jumper "
            :total="resData.total"
            :page-size="50"
            :page-sizes="[10, 50, 100]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { CITY } from "@/const/CommonConst.js";
import apiBaseURL from "@/utils/baseUrl.js";
import { postGetGroups, postSaveGroups } from "@/openapi/erp/defective.js";
import { postGetChildMarket, postGetMainMarket } from "@/openapi/erp/supply.js";
import { removeFalsy } from "@/utils/utils.js";
// 表单类型
const FORM_TYPE = {
  QUERY: "1", // 用于列表单查询的表单
  EDIT: "2", // 用于编辑的表单
};
export default {
  data() {
    return {
      FORM_TYPE,
      marketList: [], // 市场列表
      subMarketList: [], // 子市场列表
      defectiveMarketList: [], // 次品市场列表
      defectiveSubMarketList: [], // 次品子市场列表
      logVisible: false,
      editVisible: false,
      resData: null,
      logData: null,
      form: {
        market_id: "",
        pgname: "",
        market_sub_id: "",
        create_time: [],
        city: "",
        is_use: "",
        psize: 50,
        p: 1,
      },
      defective_form: {
        id: "",
        group_name: "",
        city: "",
        status: "1",
        market_id: "",
        market_sub_id: {},
        supply_grade: [],
      },
      citys: CITY,
      isUse: [
        {
          value: "1",
          label: "启用",
        },
        {
          value: "2",
          label: "禁用",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/Defective/getGroups",
      curPage: 1,
      filterFold: false,
      activeTab: "",
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    onCityChange(formType = FORM_TYPE.QUERY) {
      console.log("formType", formType);
      if (formType === FORM_TYPE.QUERY) {
        this.subMarketList = [];
        this.form.market_id = "";
        this.form.market_sub_id = "";
        this.getMainMarketByCity();
      }
      if (formType === FORM_TYPE.EDIT) {
        this.defectiveSubMarketList = [];
        this.defective_form.market_id = "";
        this.defective_form.market_sub_id = {};
        this.getMainMarketByCity(formType);
      }
    },
    getMainMarketByCity(formType = FORM_TYPE.QUERY) {
      console.log("formType", formType);
      if (formType === FORM_TYPE.QUERY) {
        postGetMainMarket({ city: this.form.city }).then((res) => {
          this.marketList = res;
        });
      }
      if (formType === FORM_TYPE.EDIT) {
        postGetMainMarket({ city: this.defective_form.city }).then((res) => {
          // 初始化市场
          this.activeTab = res[0].key;
          this.defectiveMarketList = res;
          this.getSubMarketList(formType);
        });
      }
    },
    onMainMarketChange(formType = FORM_TYPE.QUERY) {
      if (formType === FORM_TYPE.QUERY) {
        this.form.market_sub_id = "";
        this.getSubMarketList();
      }
      if (formType === FORM_TYPE.EDIT) {
        this.getSubMarketList(formType);
      }
    },
    getSubMarketList(formType = FORM_TYPE.QUERY) {
      if (formType === FORM_TYPE.QUERY) {
        postGetChildMarket({ parent_id: this.form.market_id }).then((res) => {
          this.subMarketList = res;
        });
      }
      if (formType === FORM_TYPE.EDIT) {
        postGetChildMarket({ parent_id: this.activeTab }).then((res) => {
          const { market_sub_id: marketSubIds } = this.defective_form;
          console.log("postGetChildMarket", this.defective_form, marketSubIds);
          if (!marketSubIds[this.activeTab]) {
            this.$set(this.defective_form.market_sub_id, this.activeTab, []);
          }
          this.defectiveSubMarketList = res;
        });
      }
    },
    output() {
      this.form.is_excel = 1;
      postGetGroups(removeFalsy(this.form))
        .then((res) => {
          this.form.is_excel = 0;
          window.open(apiBaseURL + res.file);
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, removeFalsy(this.form)).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.tableLoading = false;

          this.resData = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.p = val;
      this.tableLoading = true;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.psize = val;
      this.form.p = 1;
      this.tableLoading = true;
      this.fetchData();
    },
    search() {
      this.form.p = 1;
      this.loading = true;
      this.fetchData();
    },
    trim(str, isGlobal) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (isGlobal.toLowerCase() === "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    addPg() {
      this.editVisible = true;
    },
    editDg(row) {
      console.log("row", row);
      // 整理市场子节点
      const marketObject = row.market_child.reduce((acc, market) => {
        acc[market.market_id] = market.sub_market_id;
        return acc;
      }, {});
      this.defective_form = {
        id: row.dgid,
        group_name: row.group_name,
        city: row.city,
        status: row.status,
        market_id: row.market_id,
        market_sub_id: marketObject,
      };
      this.getMainMarketByCity(FORM_TYPE.EDIT);
      this.getSubMarketList(FORM_TYPE.EDIT);
      this.editVisible = true;
    },
    PgLog(row) {
      this.$http
        .post("/erp/Defective/getLog", {
          type: "group",
          id: row.dgid,
        })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.logData = res.data.data.log;
            this.logVisible = true;
          }
        });
    },
    saveDefective() {
      const { market_sub_id: marketSubId, ...rest } = this.defective_form;
      const marketSub = Object.values(marketSubId).flat();
      const params = { ...rest, market_sub_id: marketSub };
      postSaveGroups(removeFalsy(params)).then(() => {
        this.$message.success("编辑成功");
        this.closeEditDefective();
        this.fetchData(true);
      });
    },
    closeEditDefective() {
      this.editVisible = false;
      this.defective_form = this.$options.data().defective_form;
    },
    // 查看全部
    handleShowModalMore(row, name) {
      this.$set(row, `is${name}ShowAll`, !row[`is${name}ShowAll`]);
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/defectivegroup/group.vue